module.exports = ".field-title{\r\n    width:129px;\r\n    display:inline-block;\r\n    color:#807f7f;\r\n}\r\n.row{\r\n    padding:10px;\r\n}\r\n.row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}\r\n.input-group {\r\n    position: relative;\r\n    margin: 10px 0;\r\n}\r\n.mandatory{\r\n    color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Departmental-Exam/dept-exam-sanction/dept-exam-sanction-form/dept-exam-sanction-form.component.css
// module id = ./src/app/hrms/Departmental-Exam/dept-exam-sanction/dept-exam-sanction-form/dept-exam-sanction-form.component.css
// module chunks = main